import { useMemo } from 'react'

import PartHeader from '@/components/molecules/PartHeader'
import Stepper from '@/components/molecules/Stepper'
import type { Hub, Part } from '@/services/schemas'
import type { Item } from '@/stores/CartStore'
import { useHubStore } from '@/stores/HubStore'
import { useMobileLayoutStore } from '@/stores/MobileLayoutStore'
import { cn } from '@/util/cn'
import { ITEMS_PRESELECTED } from '@/util/Hardcoded'

type PartRowProps = {
  part: Part
  categoryId: string
}

const getPartsFromEveryHub = (rNumber: string, categoryId: string, hubs: Hub[]) => {
  const foundParts: Array<Item> = []

  for (const hub of hubs) {
    const category = hub.categories.find(category => category.id === categoryId)
    if (!category) continue

    const part = category.parts.find(hubPart => hubPart.RNumber === rNumber)
    if (!part) continue
    const isPreselect = ITEMS_PRESELECTED.includes(part.id)

    foundParts.push({
      amount: isPreselect ? 1 : 0,
      name: part.partname,
      categoryId: category.id,
      preselect: isPreselect ?? false,
      hubId: hub.id,
      partId: part.id,
      rNumber: part.RNumber,
      price: Number.parseFloat(part.pricing.retailprice?.toString()),
      currency: part.pricing.currency,
      limit: part.part_limit,
    })
  }
  return foundParts
}

function PartRow({ part, categoryId }: PartRowProps) {
  const { isMobile, activeMobileTab } = useMobileLayoutStore()
  const hubs = useHubStore(state => state.hubs)
  const parts = useMemo(() => {
    return getPartsFromEveryHub(part.RNumber, categoryId, hubs)
  }, [hubs, categoryId, part])

  return (
    <div className={cn(
      'grid grid-cols-4 gap-[2px] tablet:grid-cols-5',
      isMobile && activeMobileTab === 'deluxe' && 'grid-cols-4',
    )}
    >
      <PartHeader part={part} />

      {parts.map(item => (
        <Stepper
          key={item.partId}
          item={item}
        />
      ))}
    </div>
  )
}

export default PartRow
